// extracted by mini-css-extract-plugin
export var content = "ConferenceVideoSectionRight-module--content--ee39e";
export var videoWrapper = "ConferenceVideoSectionRight-module--videoWrapper--24d7e";
export var wrapper = "ConferenceVideoSectionRight-module--wrapper--5224c";